import { gql } from 'apollo-angular';

import { ADDRESS_FRAGMENT } from 'graphql/fragments/address';
import { CONDITION_FRAGMENT } from 'graphql/fragments/condition';

export const CUSTOMER_FRAGMENT = gql`
  fragment CustomerFragment on Customer {
    id
    name
    additionalNames
    association
    shareholderId
    email
    phone
    fax
    website
    deliveryTerms
    externalSales
    internalSales
    information
    baseDiscount
    surcharge
    paymentConditions
    vat
    taxId
    customerNumber
    addresses {
      ...AddressFragment
    }
    contactPersons {
      email
    }
    useCustomConditions
    conditions {
      ...ConditionFragment
    }
  }
  ${ADDRESS_FRAGMENT}
  ${CONDITION_FRAGMENT}
`;
